import React, { useEffect, useState } from 'react';

/**
 * Bandeau discret qui s'affiche quand le mode debug est actif.
 * Apparaît :
 *  - si l'utilisateur connecté est Léonce (phone = 0700000099)
 *  - ou si le flag `sada_debug` est dans le localStorage
 *
 * Position : haut de l'écran, hauteur 24 px, semi-transparent.
 * Indique l'environnement (PROD vs PREVIEW) pour éviter toute confusion.
 */
const DebugBanner = () => {
  const [visible, setVisible] = useState(false);
  const [user, setUser] = useState(null);
  const [env, setEnv] = useState('PROD');

  useEffect(() => {
    const refresh = () => {
      let u = null;
      try { u = JSON.parse(localStorage.getItem('dermascan_user') || 'null'); } catch (_) { /* ignore */ }
      const debugFlag = localStorage.getItem('sada_debug') === '1';
      const isLeonce = u?.phone === '0700000099';
      setUser(u);
      setVisible(debugFlag || isLeonce);
    };
    // Détecte l'environnement par l'URL (preview emergentagent.com vs prod phciesada.org)
    try {
      const host = window.location.hostname;
      if (host.includes('preview.emergentagent.com') || host.includes('localhost')) {
        setEnv('PREVIEW');
      } else {
        setEnv('PROD');
      }
    } catch (_) { /* ignore */ }
    refresh();
    // Re-check when storage changes (login / logout dans un autre tab)
    window.addEventListener('storage', refresh);
    // Re-check une fois après le login (dans le même tab)
    const t = setTimeout(refresh, 1500);
    return () => { window.removeEventListener('storage', refresh); clearTimeout(t); };
  }, []);

  if (!visible) return null;

  const isPreview = env === 'PREVIEW';
  const bg = isPreview ? 'bg-amber-500/95' : 'bg-fuchsia-600/95';
  const label = user?.phone === '0700000099' ? 'Léonce' : 'Mode test';

  return (
    <div
      className={`fixed top-0 left-0 right-0 ${bg} text-white text-[11px] font-medium z-[60] backdrop-blur-sm shadow-sm`}
      data-testid="debug-banner"
      role="status"
      aria-live="polite"
    >
      <div className="max-w-7xl mx-auto px-3 py-1 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <span className="inline-flex w-1.5 h-1.5 rounded-full bg-white animate-pulse" aria-hidden="true" />
          <span className="truncate">
            {isPreview ? '🧪 PREVIEW' : '🔴 PROD'} · Mode debug actif · {label}
          </span>
        </div>
        <button
          type="button"
          onClick={() => {
            try { localStorage.removeItem('sada_debug'); } catch (_) { /* ignore */ }
            if (window.eruda?.destroy) { try { window.eruda.destroy(); } catch (_) { /* ignore */ } }
            setVisible(false);
          }}
          className="hidden sm:inline-flex items-center px-2 py-0.5 rounded text-[10px] bg-white/20 hover:bg-white/30 transition-colors whitespace-nowrap"
          aria-label="Désactiver le mode debug"
          data-testid="debug-banner-disable-btn"
        >
          Désactiver
        </button>
      </div>
    </div>
  );
};

export default DebugBanner;
